import { Component, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';


import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from './laas/auth.service';
import { AdminAuthService } from './admin/admin-auth.service';
import { ECDHService } from './services/ecdh.service';
import { MatDialog } from '@angular/material/dialog';
import { OpenDialog } from './laas/dialog-for-cbs/dialog.component';
import { environment as ENV } from '../environments/environment';
// import { BnNgIdleService } from 'bn-ng-idle';

// assign the already defined variable (in index.html) a type to silence type error.
// this is Angular dependent. As TypeScript is not as lenient as JavaScript.
declare var digiCallback: any;
declare const qrcode: any;
declare var QrScanner : any;
declare var $ : any;

@Component({
  selector: 'wl-laas',
  template: `
    <router-outlet></router-outlet>
    <wl-footer></wl-footer>
  `,
  //  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  time:any;

  private sessionStartTime: number = 0;
  private sessionTimerInterval: any = null;
  private readonly SESSION_LIMIT = 30 * 60 * 1000;       // 30 minutes
  private readonly SESSION_WARNING =25 * 60 * 1000;     // 25 minutes (5 min before expiry)
  private sessionWarningShown: boolean = false;
  private sessionExpiredHandled: boolean = false;
  private refreshTokenInterval: any = null;
  private readonly REFRESH_INTERVAL = 15 * 60 * 1000; // 15 minutes
  private timersRunning: boolean = false;

  constructor(
    private auth: AuthService,
    private adminAuth: AdminAuthService,
    private router: Router,
    private ecdhService: ECDHService,
    private dialog: MatDialog
    // private bnIdle: BnNgIdleService
    // private timeoutService: TimeoutService
    ) {
    // assign the callback the actual function defined in digilocker.service.ts

  }

  // ngOnInit(){
  //   this.bnIdle.startWatching(60).subscribe((isTimedOut: boolean) => {
  //     if (isTimedOut) {
  //       console.log('session expired');
  //     }
  //   });
  // }

  ngOnInit(){
    var self = this;
    this.ecdhService.initSession().then(function () {
      // After key-exchange, if user was logged in before refresh, get a new access token
      if (self.adminAuth.adminLoggedIn()) {
        self.adminAuth.setAccessToken(null); // Clear stale token, refresh cookie will authenticate
        self.adminAuth.refreshToken().subscribe(
          function (res) {
            console.log('[App] Access token restored after refresh');
            self.adminAuth.resolveAuthReady();
          },
          function (err) {
            console.warn('[App] Failed to restore access token, redirecting to login:', err);
            self.adminAuth.resolveAuthReady();
            self.adminAuth.clearSession();
            window.location.href = '/login-admin';
          }
        );
      } else {
        self.adminAuth.resolveAuthReady();
      }
    }).catch(function (err) {
      console.warn('ECDH key-exchange failed, encryption disabled:', err.message || err);
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
          let url = event.url
          let splitUrl = url.split('/')
          console.log(splitUrl)
          if(event.url != "/admin/landing1" && (splitUrl[1]=="fresh-app" || splitUrl[0]=="fresh-app" || splitUrl[2]=="fresh-app")) {
              sessionStorage.setItem('rtItemPath','ftrwrefsh')
          }else if(event.url != "/admin/landing1" && (splitUrl[1]=="admin" || splitUrl[0]=="admin" || splitUrl[2]=="admin")){
          console.log(event.url)
          sessionStorage.setItem('rtItemPath','axdcmqihn')}

          // Start all timers once user is logged in
          if (this.isLoggedIn() && !this.timersRunning) {
            this.startAllTimers();
          }

          // Stop all timers once user logs out
          if (!this.isLoggedIn() && this.timersRunning) {
            this.stopAllTimers();
          }
      }
  });

    // If user is already logged in (e.g. page refresh), start timers
    if (this.isLoggedIn()) {
      this.startAllTimers();
    }

    // Logout when tab/browser is closed
    window.addEventListener('beforeunload', this.onBeforeUnload.bind(this));

    // Listen for login from another tab — kick this tab to login page (only if logged in)
    this.adminAuth.onLoginFromOtherTab(function () {
      if (!self.adminAuth.adminLoggedIn()) {
        return;
      }
      self.stopAllTimers();
      self.adminAuth.clearSession();
      self.dialog.closeAll();
      var dialogRef = self.dialog.open(OpenDialog, {
        data: { heading: 'Session Ended', content: 'A new login was detected from another tab. You have been logged out.' },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(function () {
        window.location.href = '/login-admin';
      });
    });
  }

  private onBeforeUnload(): void {
    var userId = sessionStorage.getItem('wl-admin-id');
    if (!userId) {
      return;
    }
    // Use synchronous XHR — only way to guarantee request completes before browser closes
    var xhr = new XMLHttpRequest();
    xhr.open('POST', ENV.nodeUrl + '/login/logout', false); // false = synchronous
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({ id: userId }));
  }

  private isLoggedIn(): boolean {
    return this.adminAuth.adminLoggedIn();
  }

  private startAllTimers(): void {
    this.timersRunning = true;
    this.resetTimer();
    this.startSessionTimer();
    this.startRefreshTokenTimer();
    console.log('[Session] All timers started');
  }

  private stopAllTimers(): void {
    this.timersRunning = false;
    this.clearAllTimers();
    console.log('[Session] All timers stopped');
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keypress', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:wheel', ['$event'])
  @HostListener('document:scroll', ['$event'])
  @HostListener('document:touchstart', ['$event'])
  resetTimer(event?: Event) {
    if (!this.timersRunning) {
      return;
    }
    if (event && !event.isTrusted) {
      return;
    }
    clearTimeout(this.time);
    this.time = setTimeout(() => {
      console.log("logout due to inactivity")
      if(document.visibilityState == 'visible'){
        this.dialog.closeAll();
        this.clearAllTimers();
        this.performLogout();

        var self = this;
        var dialogRef = this.dialog.open(OpenDialog, {
          data: {
            heading: 'Logged Out',
            content: 'You have been logged out due to inactivity. Please login again to continue.'
          },
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(function () {
          self.router.navigate(['/login-admin']);
        });
        console.log('[Session] Logged out due to inactivity');
      }
    }, 900000);// 900000 = 15 minutes
  }

  private startSessionTimer(): void {
    this.sessionStartTime = Date.now();
    this.sessionWarningShown = false;
    this.sessionExpiredHandled = false;

    if (this.sessionTimerInterval) {
      clearInterval(this.sessionTimerInterval);
    }

    var self = this;
    this.sessionTimerInterval = setInterval(function () {
      var elapsed = Date.now() - self.sessionStartTime;

      // At 25 minutes — show warning dialog
      if (!self.sessionWarningShown && elapsed >= self.SESSION_WARNING) {
        self.sessionWarningShown = true;
        self.dialog.open(OpenDialog, {
          data: {
            heading: 'Session Expiring Soon',
            content: 'Your session will expire in 5 minutes. Please save your work.'
          },
          disableClose: false
        });
        console.log('[Session] Warning: session expiring in 5 minutes');
      }

      // At 30 minutes — show expired dialog and logout
      if (!self.sessionExpiredHandled && elapsed >= self.SESSION_LIMIT) {
        self.sessionExpiredHandled = true;
        self.dialog.closeAll();
        self.clearAllTimers();
        self.performLogout();

        var dialogRef = self.dialog.open(OpenDialog, {
          data: {
            heading: 'Session Expired',
            content: 'Your session has expired after 30 minutes. You will be redirected to the login page.'
          },
          disableClose: true
        });
        dialogRef.afterClosed().subscribe(function () {
          self.router.navigate(['/login-admin']);
        });
        console.log('[Session] Expired: forced logout after 30 minutes');
      }
    }, 10000); // check every 10 seconds
  }

  private performLogout(): void {
    var userId = sessionStorage.getItem('wl-admin-id') || '';
    var self = this;
    if (userId) {
      this.adminAuth.logoutFromServer(userId).subscribe(
        function () {
          console.log('Server logout successful');
          self.adminAuth.adminLogout();
          self.stopAllTimers();
        },
        function (err) {
          console.error('Server logout failed:', err);
          self.adminAuth.adminLogout();
          self.stopAllTimers();
        }
      );
    } else {
      this.auth.logout();
      this.stopAllTimers();
    }
  }

  private startRefreshTokenTimer(): void {
    if (this.refreshTokenInterval) {
      clearInterval(this.refreshTokenInterval);
    }
    if (sessionStorage.getItem('wl-session-active') !== 'true') {
      return;
    }
    var self = this;
    this.refreshTokenInterval = setInterval(function () {
      if (sessionStorage.getItem('wl-session-active') === 'true') {
        self.adminAuth.refreshToken().subscribe(
          function (res) { console.log('[Session] Token refreshed successfully'); },
          function (err) { console.error('[Session] Token refresh failed:', err); }
        );
      }
    }, self.REFRESH_INTERVAL);
  }

  private clearAllTimers(): void {
    clearTimeout(this.time);
    if (this.sessionTimerInterval) {
      clearInterval(this.sessionTimerInterval);
      this.sessionTimerInterval = null;
    }
    if (this.refreshTokenInterval) {
      clearInterval(this.refreshTokenInterval);
      this.refreshTokenInterval = null;
    }
  }

}
